import React from 'react';
import YouTube, { Options } from 'react-youtube';
import { useTrackingManager } from '../../hooks/use-tracking-manager';
import { onVWBasicLinkClickEvent } from '../../tagging/tagging-helpers';
import { Wrapper } from './styles';

interface YouTubeVideoPlayerProps {
  readonly videoId?: string;
  readonly videoMargin?: string;
  readonly videoWidth?: string;
  readonly videoMaxWidth?: string;
}

const YouTubeVideoPlayer: React.FC<YouTubeVideoPlayerProps> = props => {
  const trackingMananger = useTrackingManager();

  const defaultSetting: Options = {
    playerVars: { rel: 0 },
  };

  // Tagging Events
  const handleTracking = () => {
    trackingMananger &&
      onVWBasicLinkClickEvent(
        {
          url: `https://www.youtube.com/watch?v=${props.videoId}`,
          newTab: false,
        },
        { ItemCount: 1, ItemPosition: 1 },
        trackingMananger,
      );
  };

  return (
    <Wrapper
      videoMaxWidth={props.videoMaxWidth}
      videoWidth={props.videoWidth}
      videoMargin={props.videoMargin}
    >
      {props.videoId && (
        <YouTube
          className="youtubeContainer" // This class is passed to the iframe not to the wrapper
          videoId={props.videoId}
          opts={defaultSetting}
          onPlay={handleTracking}
          onPause={handleTracking}
        />
      )}
    </Wrapper>
  );
};

export default YouTubeVideoPlayer;
